import { lazyLoad } from '@react-page/editor';
import createPlugin from './createPlugin';
import SimpleTextHtmlRenderer from './Renderer/SimpleTextHtmlRenderer';
const SimpleTextControls = lazyLoad(() => import('./Controls/SimpleTextControls'));
const simpleTextPlugin = (settings) => createPlugin(Object.assign({ Renderer: SimpleTextHtmlRenderer, Controls: SimpleTextControls }, settings));
const simpleText = simpleTextPlugin();
export default simpleText;
export { simpleTextPlugin };
//# sourceMappingURL=index.js.map